"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateProfileContract = void 0;
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../schemas");
const profile_request_1 = require("./profile.request");
const profile_response_1 = require("./profile.response");
const c = (0, core_1.initContract)();
exports.CandidateProfileContract = c.router({
    deleteAccount: {
        method: 'DELETE',
        path: '/',
        body: profile_request_1.DeleteAccountRequestSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    find: {
        method: 'GET',
        path: '/',
        responses: {
            200: profile_response_1.ProfileGetResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    update: {
        method: 'PATCH',
        path: '/profile',
        body: profile_request_1.UpdateProfileRequestSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    updateExperience: {
        method: 'PATCH',
        path: '/experience',
        body: profile_request_1.ProfileExperienceUpdateRequestSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    updateJobPreference: {
        method: 'PATCH',
        path: '/job-preferences',
        body: profile_request_1.ProfileJobPreferencesUpdateRequestSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    updatePersonalDetail: {
        summary: 'Update employee profile',
        method: 'PATCH',
        path: '/personal-details',
        body: profile_request_1.ProfilePersonalDetailUpdateRequestSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    updateRegistration: {
        method: 'PATCH',
        path: '/registration',
        body: profile_request_1.UpdateRegistrationRequestSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    updateSelfIntroduction: {
        method: 'PATCH',
        path: '/self-introduction',
        body: profile_request_1.ProfileSelfIntroUpdateRequestSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    updateWorkHistory: {
        method: 'PATCH',
        path: '/work-history',
        body: profile_request_1.ProfileWorkHistoryUpdateRequestSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
}, {
    pathPrefix: '/profile',
    commonResponses: { 500: schemas_1.BaseErrorResponseSchema },
});
